import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';

export const getRecordingFilesList = createAsyncThunk(
    "recordingFiles/getRecordingFilesList",
    async (request) => {
        try {
            let vdoTypeIds = '';
            if (request.videoTypes.length > 0) {
                vdoTypeIds = request.videoTypes.join(',');
            }

            let agencyIdList = '';
            if (request.agencyIds.length > 0) {
                agencyIdList = request.agencyIds.join(',');
            }
            const response = await Rest.get(
                ApiGatewayUrl +
                "/recordingfiles?page=" + request.page +
                '&rowsPerPage=' + request.rowsPerPage +
                '&agencyIds=' + agencyIdList +
                '&filterText=' + request.filterText +
                '&startDate=' + request.startDate +
                '&endDate=' + request.endDate +
                '&videoTypes=' + vdoTypeIds
            );
            return response.data
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const getRecordingFileById = createAsyncThunk(
    "recordingFiles/getRecordingFileById",
    async (recordingFileId) => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/recordingfiles/" + recordingFileId);
            return response.data
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const getRecordingMediaInfo = createAsyncThunk(
    "recordingFiles/getRecordingMediaInfo",
    async (request) => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/recordingfiles/getPlaybackUrl?recordingFileId=" + request.recordingFileId 
                + "&fileDownloadName="
            );
            return response.data
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const getDownloadMediaInfo = createAsyncThunk(
    "recordingFiles/getDownloadMediaInfo",
    async (request) => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/recordingfiles/getDownloadUrl?recordingFileId=" + request.recordingFileId
                + "&fileDownloadName=" + request.fileDownloadName
                );
            return response.data
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const deleteRecordingFile = createAsyncThunk(
    "recordingFiles/deleteRecordingFile",
    async (recordingFileId) => {
        try {
            const response = await Rest.delete(ApiGatewayUrl + "/recordingfiles/" + recordingFileId);
            return response.data
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);


export const downloadTrimVideo = createAsyncThunk(
    "recordingFiles/downloadTrimVideo",
    async (request) => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/recordingfiles/downloadTrimVideo?recordingFileId=" + request.recordingFileId
                + "&startTime=" + request.startTime
                + "&endTime=" + request.endTime
            );
            return response.data
        } catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const recordingFilesSlice = createSlice({
    name: "recordingFiles",
    initialState: {
        recordingFilesList: [],
        videoTypeList: [], 
        total: 0,
        mediaUrl: '',
        recordingFile: null,
        downloadUrl: '',
        trimDownloadUrl: ''
    },
    reducers: {

        clearDownloadUrl: (state) => {
            state.downloadUrl = '';
            state.trimDownloadUrl = '';
        },
        updateDownloadUrl: (state, action) => {
            state.downloadUrl = action.payload;
        },
        updateTrimDownloadUrl: (state, action) => {
            state.trimDownloadUrl = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getRecordingFilesList.fulfilled, (state, action) => {
                return {
                    ...state,
                    recordingFilesList: action.payload.recordingFilesList,
                    videoTypeList: action.payload.videoTypeList,
                    total: action.payload.total
                }

            })

            .addCase(getRecordingFileById.fulfilled, (state, action) => {
                return {
                    ...state,
                    recordingFile: action.payload
                }
            })

            .addCase(getRecordingMediaInfo.fulfilled, (state, action) => {
                return {
                    ...state,
                    mediaUrl: action.payload.mediaUrl
                }
            })

            .addCase(getDownloadMediaInfo.fulfilled, (state, action) => {
                return {
                    ...state,
                    downloadUrl: action.payload.mediaUrl
                }
            })

    }
});

export const recordingFilesActions = recordingFilesSlice.actions;
export const recordingFilesState = (state) => state.recordingFiles;
export default recordingFilesSlice.reducer;